module.exports = "/dashboard/manage/locations/locations-table-9a8290.html";